import { TextField } from '@mui/material';
import styled from '@emotion/styled';
import { Box } from '@mui/material/';
import { BASE_FIELD_BACKGROUND_COLOR, FIELD_BACKGROUND_DISABLED } from '../../themes/tokens';

export const FormGridInput = styled(TextField)`
  background-color: ${BASE_FIELD_BACKGROUND_COLOR};
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  > label {
    display: flex;
    align-items: center;

    > span {
      color: #b00020;
    }
  }

  > div {
    border-radius: 8px;

    &.Mui-disabled {
      background-color: ${FIELD_BACKGROUND_DISABLED};
    }
  }
`;

export const LabelBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;

  > svg {
    cursor: pointer;
  }
`;
